module.exports = __webpack_public_path__ + "static/media/shutterstock-383617564.01f75162.png";